module.exports = __webpack_public_path__ + "static/img/ice-cream-1.0977706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ice-cream-1.png
// module id = uDnu
// module chunks = 0